// @ts-nocheck

import React from 'react';
import './LoadingScreen.css';

const LINES_COUNT = 30;

const generateLines = () => {
  const lines = [];
  for (let i = 0; i < LINES_COUNT; i++) {
    // Случайно выбрать сторону старта: top, bottom, left, right
    const side = ['top', 'bottom', 'left', 'right'][Math.floor(Math.random() * 4)];
    const startPos = Math.random() * 100; // процент
    lines.push({ id: i, side, startPos });
  }

  return lines;
};

const LoadingScreen = ({ fadeOut }: any) => {
  const lines = React.useMemo(() => generateLines(), []);

  return (
    <div className={`loader-wrapper ${fadeOut ? 'fade-out' : ''}`}>
      <div className="lines-container">
        {lines.map(({ id, side, startPos }) => (
          <div
            key={id}
            className={`line line-${side}`}
            style={{ ['--start-pos']: `${startPos}%`, animationDelay: `${id * 0.1}s` }}
          />
        ))}
      </div>
      <div className="center-text">{window.config.STORE_NAME || 'BLACK SITE'}</div>
    </div>
  );
};
export default LoadingScreen